/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { StyledIframe } from "src/components/Block/BlockTypes/LinkBlock/styles";

interface Props {
  embedId: string;
  disableMouse: boolean;
}

export const InstagramEmbed = ({ embedId, disableMouse }: Props) => {
  return (
    <StyledIframe
      title={`instagram-${embedId}`} //@todo these are dumb
      src={`https://www.instagram.com/p/${embedId}embed`}
      width="100%"
      height="100%"
      frameBorder="0"
      allowFullScreen
      disableMouse={disableMouse}
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
    />
  );
};
